import React, { useEffect, useRef, useState } from 'react'
import { Save, Slash } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { ChangedServiceFromOrder } from '../../../../app/store/ordenes/thunks';

export const ChangedServicios = ({ selectedService, folio }) => {

    const dispatch = useDispatch();
    const { servicios } = useSelector(state => state.catalogos);
    const [ServicioSelected, setServicioSelected] = useState(null);
    const optionsSelect = servicios.filter((item) => item.ESTADO === '1').map((item) => ({
        value: item.ID,
        label: `${item.NOMBRE.toUpperCase()} - $${item.COSTO_SERV}`
    }));

    // console.log(selectedService);
    // console.log(folio);

    const closeModal = useRef(null);

    const clearForm = () => {
        setServicioSelected(null);
    }

    useEffect(() => {
        // Podrías poner lógica aquí si quieres hacer algo más, como preseleccionar algún valor
        // por ahora sólo limpiar
        setServicioSelected(null);
    }, [selectedService]);


    const saveChanges = () => {

        if (!ServicioSelected) {
            Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'Debes seleccionar un nuevo servicio.',
                confirmButtonText: 'Aceptar'
            });
            return; // No sigue ejecutando nada
        }
        // Cierra manualmente el modal de Bootstrap
        closeModal.current.click();

        setTimeout(() => {
            Swal.fire({
                title: 'Confirmación de cambio de servicio',
                input: 'password',
                inputLabel: 'Ingresa tu contraseña',
                inputPlaceholder: 'Escribe tu contraseña...',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false,
                focusConfirm: true,
                inputValidator: (value) => {
                    if (!value) return 'Debes ingresar un valor';
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    let password = result.value;
                    dispatch(ChangedServiceFromOrder(folio, selectedService.ID, ServicioSelected?.value, password))
                }
            });
        }, 300);

        clearForm();
    }

    return (
        <div className="modal fade" id="changedService" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 fw-bold" id="exampleModalLabel">Cambio de Servicio</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearForm}></button>
                    </div>
                    <div className="modal-body">

                        <div className='row'>
                            <div className="mb-1">
                                <label className="form-label ">Nombre:</label>
                                <input type="text" className="form-control" id="exampleFormControlInput1" value={selectedService?.NOMBRE || ""} disabled />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Descripción:</label>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={selectedService?.DESCRIPCION || ""} disabled></textarea>
                            </div>
                        </div>

                        <div className='row'>


                            <div className='mb-1'>
                                <span className="badge text-bg-primary mb-1">Nuevo Servicio</span><br />
                                <Select id='servicio_realizar'
                                    className='w-100'
                                    options={optionsSelect}
                                    placeholder="Selecciona / Busca un servicio"
                                    // onChange={(selectedOption) => console.log('Selected:', selectedOption)}
                                    noOptionsMessage={() => "No se han encontraron resultados"}
                                    onChange={(ServicioSelected) => setServicioSelected(ServicioSelected)} // Actualiza el estado
                                    isClearable
                                />
                            </div>
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button ref={closeModal} type="button" className="btn btn-outline-danger" data-bs-dismiss="modal" onClick={clearForm}><Slash size={22} /> Cancelar</button>
                        <button type="button" className="btn btn-outline-primary" onClick={() => saveChanges()} disabled={!ServicioSelected} > <Save size={22} />Guardar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
